//@flow

import * as React from 'react'
import { Modal as SUIModal, Header, Button, Icon } from 'semantic-ui-react'

type Props = {|
  open: boolean,
  content: React.Node,
  trigger?: React.Node,
  header?: React.Node,
  onConfirm?: Function,
  onCancel?: Function,
|}

const Modal = (props: Props) => (
  <SUIModal trigger={props.trigger} open={props.open} basic size="small">
    {props.header}
    {!props.header && <Header icon="help" content="Confermare azione" />}
    <SUIModal.Content>{props.content}</SUIModal.Content>
    <SUIModal.Actions>
      {props.onCancel && (
        <Button basic color="red" inverted onClick={props.onCancel}>
          <Icon name="remove" /> Annulla
        </Button>
      )}
      {props.onConfirm && (
        <Button color="green" inverted onClick={props.onConfirm}>
          <Icon name="checkmark" /> Continua
        </Button>
      )}
    </SUIModal.Actions>
  </SUIModal>
)

export default Modal



// WEBPACK FOOTER //
// ./src/systemwide/modal.js